import { render, staticRenderFns } from "./tooltipicon.vue?vue&type=template&id=82dc1366&scoped=true&"
import script from "./tooltipicon.vue?vue&type=script&lang=js&"
export * from "./tooltipicon.vue?vue&type=script&lang=js&"
import style0 from "./tooltipicon.vue?vue&type=style&index=0&id=82dc1366&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82dc1366",
  null
  
)

export default component.exports